import React, {Component} from 'react';
import {ModalContainer, ModalRoute} from 'react-router-modal';
import {Route, Redirect, Switch, Link} from 'react-router-dom';
import DocumentTile from 'react-document-title';
import intl from 'react-intl-universal';
import {debounce} from 'underscore';
import {mobilecheck} from './utils/Utils'

import './ComapFrontend.css';

import MapContainer from './scenes/MapContainer';
import Survey from './scenes/Survey';
import EndLanding from './scenes/EndLanding';
import CloseSurvey from './scenes/CloseSurvey';
import Landing from "./scenes/Landing";
import Error from "./scenes/Error";

const locales = {
    "en-US": require('./locales/en-US.js'),
    "zh-CN": require('./locales/zh-CN.js')
};

class MapWrapper extends Component {
    render() {
        if (this.props.appStore.introModal) {
            return (
                <Redirect to="/info"/>
            )
        } else {
            return (
                <DocumentTile
                    title={intl.get('DocumentTitle.map_page', {branch_name: this.props.appStore.branchDisplayName})}>
                    <MapContainer/>
                </DocumentTile>
            )
        }
    }
}

class ComapFrontend extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initDone: false
        };
        this._handleWindowResize = debounce(this._handleWindowResize.bind(this), 100);
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;

        this.loadLocales();

        window.addEventListener('resize', this._handleWindowResize);

        // https://stackoverflow.com/questions/7317273/warn-user-before-leaving-web-page-with-unsaved-changes
        this.props.appStore.exitConfirmation = (e) => {
            let confirmationMessage = intl.get('DialogMessage.pagereload');

            (e || window.event).returnValue = confirmationMessage; //Gecko + IE
            return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
        };
                // https://stackoverflow.com/questions/7317273/warn-user-before-leaving-web-page-with-unsaved-changes
            window.addEventListener("beforeunload", this.props.appStore.exitConfirmation);
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('resize', this._handleWindowResize);
    }

    _handleWindowResize() {
        if (this._isMounted) {
            this.props.appStore.setIsMobile(mobilecheck());
        }
    }

    loadLocales() {
        intl.init({
            currentLocale: 'en-US',
            locales
        }).then(() => {
            this.setState({
                initDone: true
            });
        });
    }


    isClosed = (appStore) => {
        const meta = appStore.meta;
        if (meta && meta.phase && meta.phase.production && meta.phase.production['CLOSED'] === true) {
            return true;
        }
        return false;
    };

    render() {
        const {appStore} = this.props;
        const branchDisplayName = appStore.branchDisplayName;

        const SurveyModal = ({history}) => {
            return (
                <DocumentTile title={intl.get('DocumentTitle.survey_modal', {branch_name: branchDisplayName})}>
                    <Survey appStore={appStore}
                            history={history}
                    />
                </DocumentTile>
            )
        };

        const LandingModal = ({history}) => {
            return (
                <Landing appStore={appStore}
                         history={history}/>
            )
        };

        const ErrorPage = ({history}) => {
            return (
                <DocumentTile title={intl.get('DocumentTitle.error_page', {branch_name: branchDisplayName})}>
                    <Error appStore={appStore}
                           history={history}/>
                </DocumentTile>
            )
        };

        const End = () => {
            return (
                <DocumentTile title={intl.get('DocumentTitle.end_page', {branch_name: branchDisplayName})}>
                    <EndLanding/>
                </DocumentTile>
            )
        };

        const Close = () => {
            return (
                <DocumentTile title={intl.get('DocumentTitle.closed', {branch_name: branchDisplayName})}>
                    <CloseSurvey/>
                </DocumentTile>
            )
        };

        return (
            this.state.initDone &&
            <div className="ComapFrontend">
                <Link aria-label="Skip to info page"
                      className="offscreen"
                      to={`/info`}>Skip to Info Page</Link>
                <Link aria-label="Skip to survey page"
                      className="offscreen"
                      to={`/survey`}>Skip to Survey Page</Link>
                <Switch>
                    <Route exact path="/" render={() => <MapWrapper appStore={this.props.appStore}/>}/>
                    <Route exact path="/info" render={() => <MapContainer/>}/>
                    <Route exact path="/survey" render={() => <MapWrapper appStore={this.props.appStore}/>}/>
                    <Route exact path="/end" component={End}/>
                    <Route component={ErrorPage}/>
                </Switch>
                <ModalRoute component={LandingModal} path='/info'/>
                <ModalRoute component={SurveyModal} path='/survey'/>
                <ModalContainer/>
                {this.isClosed(appStore) && Close()}

            </div>
        );
    }
}

export default ComapFrontend;



// WEBPACK FOOTER //
// ./src/ComapFrontend.js